'use client'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import {
  transformConversationResponse,
  createItemConversationThread,
  createInquiryNew,
  ConversationInitiatorType,
} from '@marketplace-web/messaging/conversation-messaging-data'

export const useCreateConversation = () => {
  const isWebMessagingSvcFSEnabled = useFeatureSwitch('web_messaging_svc')

  const { fetch: createItemConversation, transformedData: conversationData } = useFetch(
    createItemConversationThread,
    response => transformConversationResponse(response.conversation),
  )

  const { fetch: createInquiry, transformedData: inquiryData } = useFetch(
    createInquiryNew,
    response => ({ id: response.conversation_id }),
  )

  const createConversation = ({
    itemId,
    receiverId,
    initiator,
  }: {
    itemId: number
    receiverId: string
    initiator: ConversationInitiatorType
  }) => {
    if (isWebMessagingSvcFSEnabled) {
      createInquiry({
        itemIds: [itemId],
        receiverId,
      })

      return
    }

    createItemConversation({
      itemId: itemId.toString(),
      receiverId,
      initiator,
    })
  }

  const conversation = isWebMessagingSvcFSEnabled ? inquiryData : conversationData

  return { createConversation, conversation }
}

export default useCreateConversation
